module.exports = __webpack_public_path__ + "img/9788993635515.38a6cd27.jpg";